import React from 'react';
import cn from 'classnames';

import { Checkbox, DynamicIconWrapper } from '@components/common';

import { IIconProps } from '@icons/interface';

import { IChecklistProps } from '@components/common/Checklist/Checklist.types';

interface IChecklistItemProps extends Omit<IChecklistProps, 'viewIcon' | 'editIcon' | 'deleteIcon' | 'data'> {
	id?: string;
	value: string;
	label: string;
	isChecked: boolean | 'indefinite';
	handleChange: (checked: boolean, name: string) => void;
	viewIcon: (props: IIconProps) => React.ReactElement;
	editIcon: (props: IIconProps) => React.ReactElement;
	deleteIcon: (props: IIconProps) => React.ReactElement;
	style?: React.CSSProperties;
	isViewActionAvailable?: boolean;
}

const ChecklistItem = ({
	classNames,
	deleteActionTooltip,
	deleteHandler,
	deleteIcon,
	editActionTooltip,
	editHandler,
	editIcon,
	handleChange,
	id,
	isChecked,
	isViewActionAvailable,
	label,
	style,
	value,
	viewActionTooltip,
	viewHandler,
	viewIcon,
}: IChecklistItemProps) => {
	const handleView = () => {
		if (!viewHandler) return;

		viewHandler({ value, label });
	};

	const isIndefinite = isChecked === 'indefinite';

	const handleDelete = () => {
		if (!deleteHandler) return;

		deleteHandler({ value, label });
	};

	const handleEdit = () => {
		if (!editHandler) return;

		editHandler({ value, label });
	};

	return (
		<div
			key={id}
			className={cn('f5gChecklist-item', classNames?.item)}
			style={style}
		>
			<Checkbox
				checked={!isIndefinite && isChecked}
				isIndefinite={isChecked === 'indefinite'}
				label={label}
				name={value}
				onChange={handleChange}
			/>
			<div className={cn('f5gChecklist-actions', classNames?.actionsContainer)}>
				{viewHandler && isViewActionAvailable && (
					<DynamicIconWrapper
						icon={viewIcon}
						onClick={handleView}
						tooltipLabel={viewActionTooltip}
					/>
				)}
				{editHandler && (
					<DynamicIconWrapper
						icon={editIcon}
						onClick={handleEdit}
						tooltipLabel={editActionTooltip}
					/>
				)}
				{deleteHandler && (
					<DynamicIconWrapper
						icon={deleteIcon}
						onClick={handleDelete}
						tooltipLabel={deleteActionTooltip}
					/>
				)}
			</div>
		</div>
	);
};

export default ChecklistItem;
